<template>
  <div class="form-container">
    <h5>Editar Status da Indicacao</h5>

    <div class="form-group mt-3">
      <label><strong>Status atual:</strong></label>
      <p :title="currentStatus.description"><strong>{{ currentStatus.name }}</strong></p>
    </div>

    <div class="form-group">
      <label for="status-select">Novo status</label>
      <select
        v-model="selectedStatusId"
        id="status-select"
        class="browser-default custom-select"
      >
        <option :value="null" disabled>Selecione um status</option>
        <option
          v-for="status in driverIndicationStatuses"
          :key="status.id"
          :value="status.id"
          :title="status.description"
        >
          {{ status.name }} ({{ status.code }})
        </option>
      </select>
    </div>

    <div class="mt-3 text-right">
      <button class="btn btn-outline mr-2" @click="$emit('cancel')">
        Cancelar
      </button>
      <button
        class="btn btn-primary"
        :disabled="!canSave"
        @click="save"
      >
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverIndicationForm',
  props: {
    indication: { required: true, type: Object },
    driverIndicationStatuses: { required: true, type: Array }
  },
  data() {
    return {
      selectedStatusId: this.indication.driverIndicationStatusId || this.indication.driver_indication_status_id || null,
      saving: false
    }
  },
  computed: {
    currentStatus() {
      const statusId = this.indication.driverIndicationStatusId || this.indication.driver_indication_status_id
      return this.driverIndicationStatuses.find(s => s.id === statusId)
    },
    canSave() {
      const currentId = this.indication.driverIndicationStatusId || this.indication.driver_indication_status_id
      return this.selectedStatusId && this.selectedStatusId !== currentId && !this.saving
    }
  },
  methods: {
    async save() {
      this.saving = true
      try {
        await this.axios.put(
          `admin/maestro/driver_indications/${this.indication.id}`,
          { driver_indication_status_id: this.selectedStatusId }
        )
        this.$notify.add('Status atualizado com sucesso!')
        this.$emit('saved')
      } catch (e) {
        this.$notify.addError(e)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
</style>
